module.exports = __webpack_public_path__ + "img/schale_3_a.3ed08ae5.jpg";